import React, { useEffect, useState } from "react";
import AdminLayout from "../layout";
import { getBanner, saveBanner } from "./FetchApi";

const BannerForm = () => {
  const [form, setForm] = useState({
    text: "",
    bgColor: "#1e40af",
    textColor: "#ffffff",
    endAt: "",
    enabled: false,
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const load = async () => {
      const res = await getBanner();
      if (res && res.banner) {
        const { text, bgColor, textColor, endAt, enabled } = res.banner;
        setForm({
          text: text || "",
          bgColor: bgColor || "#1e40af",
          textColor: textColor || "#ffffff",
          endAt: endAt ? new Date(endAt).toISOString().slice(0, 16) : "",
          enabled: !!enabled,
        });
      }
    };
    load();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage("");
    // Basic client-side validation for color format to avoid 400 from server
    const colorRegex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
    if (form.bgColor && !colorRegex.test(form.bgColor)) {
      setSaving(false);
      setMessage("Couleur invalide. Utilisez un code hex ex: #1e40af");
      return;
    }
    if (form.textColor && !colorRegex.test(form.textColor)) {
      setSaving(false);
      setMessage("Couleur de texte invalide. Utilisez un code hex ex: #ffffff");
      return;
    }
    const payload = {
      text: form.text,
      bgColor: form.bgColor,
      textColor: form.textColor,
      endAt: form.endAt ? new Date(form.endAt).toISOString() : null,
      enabled: form.enabled,
    };
    const res = await saveBanner(payload);
    setSaving(false);
    if (res && res.success) {
      setMessage("Bannière enregistrée avec succès.");
    } else if (res && res.error) {
      setMessage(res.error);
    } else {
      setMessage("Erreur lors de l'enregistrement.");
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Bannière promotionnelle</h1>
      <form onSubmit={onSubmit} className="bg-white rounded-lg shadow p-4 space-y-4 max-w-2xl">
        <div>
          <label className="block text-sm font-medium mb-1">Texte</label>
          <input
            type="text"
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={form.text}
            onChange={(e) => setForm({ ...form, text: e.target.value })}
            placeholder="Ex: -30% sur toute la boutique ce week-end !"
          />
        </div>
        <div className="flex items-center gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium mb-1">Couleur de fond</label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                className="h-10 w-16 border rounded"
                value={form.bgColor}
                onChange={(e) => setForm({ ...form, bgColor: e.target.value })}
              />
              <input
                type="text"
                className="flex-1 border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={form.bgColor}
                onChange={(e) => setForm({ ...form, bgColor: e.target.value })}
                placeholder="#1e40af"
              />
            </div>
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium mb-1">Couleur du texte</label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                className="h-10 w-16 border rounded"
                value={form.textColor}
                onChange={(e) => setForm({ ...form, textColor: e.target.value })}
              />
              <input
                type="text"
                className="flex-1 border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={form.textColor}
                onChange={(e) => setForm({ ...form, textColor: e.target.value })}
                placeholder="#ffffff"
              />
            </div>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex-1">
            <label className="block text-sm font-medium mb-1">Fin de l'offre (optionnel)</label>
            <input
              type="datetime-local"
              className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={form.endAt}
              onChange={(e) => setForm({ ...form, endAt: e.target.value })}
            />
          </div>
        </div>
        <div className="flex items-center gap-3">
          <input
            id="enabled"
            type="checkbox"
            className="h-4 w-4"
            checked={form.enabled}
            onChange={(e) => setForm({ ...form, enabled: e.target.checked })}
          />
          <label htmlFor="enabled" className="text-sm">Activer la bannière</label>
        </div>
        <div className="flex items-center gap-3">
          <button
            type="submit"
            disabled={saving}
            className="px-4 py-2 rounded-lg bg-blue-800 text-white hover:bg-blue-700 disabled:opacity-60"
          >
            {saving ? "Enregistrement..." : "Enregistrer"}
          </button>
          {message && <span className="text-sm text-gray-700">{message}</span>}
        </div>
      </form>
      <div className="mt-6">
        <h2 className="text-sm font-medium mb-2">Aperçu</h2>
        {form.enabled && (
          <div className="rounded-md px-4 py-2" style={{ backgroundColor: form.bgColor, color: form.textColor }}>
            {form.text || "Prévisualisation de la bannière"}
          </div>
        )}
      </div>
    </div>
  );
};

const BannerAdmin = () => {
  return <AdminLayout children={<BannerForm />} />;
};

export default BannerAdmin;
